export default __webpack_public_path__ + "static/media/carousel3.e7f4a47a.jpg";